import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'

import { getServerLikesActive } from '@wwt/core/admin'
import { TutorialStatus, useTutorialStore } from '@wwt/core/tutorial'
import DoubleLikeIcon from '@wwt/shared/assets/icons/outline/doudle-like.svg'

import { useLikeIds } from '@/entities/likeDislike'
import { cn } from '@/shared/lib/cn'
import { Badge } from '@/shared/ui/Badge.tsx'
import { Button, ButtonProps } from '@/shared/ui/Button'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/shared/ui/Tooltip'

export const LikesButton = ({ className, ...props }: ButtonProps) => {
	const { t } = useTranslation('tooltips')

	const [open, setOpen] = useState(false)

	const likeIdsResponse = useLikeIds()
	const tutorialStatus = useTutorialStore.use.tutorialStatus()
	const incrementStep = useTutorialStore.use.incrementStep()

	const countOfLiked =
		likeIdsResponse.data &&
		likeIdsResponse.data &&
		Object.keys(likeIdsResponse.data).length

	const hasOffers = Boolean(countOfLiked && countOfLiked > 0)

	const handleClick = useCallback(() => {
		if (tutorialStatus !== TutorialStatus.GOING) return
		incrementStep()
	}, [incrementStep, tutorialStatus])

	return (
		<Tooltip
			open={open && tutorialStatus !== TutorialStatus.GOING}
			onOpenChange={setOpen}
		>
			<TooltipTrigger asChild={hasOffers}>
				<Button
					className={cn(
						'relative',
						!hasOffers && 'pointer-events-none',
						className
					)}
					variant="tertiary"
					size="icon-sm"
					/* Set data-wwt-id only if button active for track correct clicks */
					data-wwt-id={
						hasOffers
							? 'header__like-link--unique'
							: 'header__like-link-not-active--unique'
					}
					onClick={handleClick}
					asChild
					{...props}
				>
					<Link to="/comparison">
						<div
							className={cn(
								'relative h-full w-full overflow-hidden rounded-md bg-inherit',
								getServerLikesActive() &&
									(likeIdsResponse.isFetching || likeIdsResponse.isPending) &&
									'before:to-brand-200 before:absolute before:inset-[-50%] before:animate-spin before:bg-conic before:from-transparent before:via-transparent'
							)}
						>
							<div className="absolute inset-0 m-auto flex aspect-square w-[calc(100%-0.4rem)] items-center justify-center rounded-[0.8rem] bg-inherit">
								<DoubleLikeIcon />
								<span className="sr-only">{t('transitionToComparison')}</span>
							</div>
						</div>

						{hasOffers && (
							<Badge className="absolute -top-1 -right-[0.2rem]">
								{countOfLiked}
							</Badge>
						)}
					</Link>
				</Button>
			</TooltipTrigger>
			<TooltipContent>
				{hasOffers ? t('transitionToComparison') : t('notEnoughLikes')}
			</TooltipContent>
		</Tooltip>
	)
}
